module.exports = __webpack_public_path__ + "img/logo@2xW.081f487d.png";